export const errorMap: { [id: string]: string } = {
  'auth/user-not-found':
    'There is no user record corresponding to this identifier. The user may have been deleted.',
  'auth/invalid-email': 'The email address is not valid',
  'auth/wrong-password':
    'The password is invalid or the user does not have a password.'
};
